<template>
  <fragment>
    <div class="cart-drawer-empty__wrapper">
      <div class="f fdc x old-pt-6 old-pr-6 old-pl-6">
        <div class="cart-drawer__header empty-cart">
          <div class="x f aic cart-drawer__header-inner">
            <button
              class="close cart"
              v-on:click="toggle"
              aria-label="close cart"
            >
              <span class="f cursor--pointer">
                <svg-caret-left></svg-caret-left>
              </span>
            </button>
            <h1 id="cart-title" class="mv0 plaid-l">
              {{ cartTitle }}({{ cart.item_count }})
            </h1>
          </div>
        </div>
        <p
          class="lg--fs-30 sm--fs-28 lh-12 ls--10 chelt c-gray lg--pr-4 eleven-twelfths"
          style="z-index: 1"
        >
          <span v-html="cartEmptyCopy"></span>
        </p>
        <div class="x cart-drawer__collection-button-container">
          <div class="old-mb-4 old-pt-10">
            <a
              href="/collections/all"
              class="br-8 cart-drawer__collection-button plaid-l c-white h-bg-gray bg-old-spice x old-p-3 old-block rel fs-14 caps transition"
            >
              Shop the Collection
            </a>
          </div>
        </div>
      </div>
      <div class="cart-drawer__image-container">
        <img
          class="lazyload"
          loading="lazy"
          :src="cartImageSrc"
          :data-src="cartImageDataSrc"
          :width="cartImageWidth"
          :height="cartImageHeight"
          :alt="cartImageAlt || ''"
        />
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "cart-drawer-empty",
  props: {
    cart: Object,
    cartTitle: String,
    cartEmptyCopy: String,
    shippingCopy: String,
    cartImageSrc: String,
    cartImageDataSrc: String,
    cartImageWidth: String,
    cartImageHeight: String,
    cartImageAlt: String,
  },
  methods: {
    ...mapActions({
      toggle: "cart/toggleCart",
    }),
  },
};
</script>
